import { Save } from 'lucide-react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const FormDraftBadge: FC = () => {
  const { t } = useTranslation(['component']);
  return (
    <Badge variant="secondary">
      <Save />
      <span>{t('component:badge.formDraft')}</span>
    </Badge>
  );
};
